export const FETCH_FAVORITE_CHANNELS_INIT = 'FETCH_FAVORITE_CHANNELS_INIT';
export const FETCH_FAVORITE_CHANNELS_SUCCESS = 'FETCH_FAVORITE_CHANNELS_SUCCESS';
export const FETCH_FAVORITE_CHANNELS_ERROR = 'FETCH_FAVORITE_CHANNELS_ERROR';
export const TOGGLE_SHOW_FAVORITE_CHANNELS = 'TOGGLE_SHOW_FAVORITE_CHANNELS';
export const ADD_CHANNEL_TO_FAVORITE = 'ADD_CHANNEL_TO_FAVORITE';
export const REMOVE_CHANNEL_FROM_FAVORITE = 'REMOVE_CHANNEL_FROM_FAVORITE';
